import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { reportesDTO } from '../entidades/entidades.component';
import { AveriasService } from '../servicios/averias.service';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { DatePipe } from '@angular/common';
import { AnalyticsService } from '../servicios/analytics.service';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { NbCheckboxModule } from '@nebular/theme';
import { NbToggleModule } from '@nebular/theme';

@Component({
    selector: 'app-options-reportes',
    templateUrl: './options-reportes.component.html',
    styleUrls: ['./options-reportes.component.css'],
    standalone: true,
    imports: [SpinnerComponent, 
      FormsModule,CommonModule,
      NbCardModule,NbIconModule,
      DropdownModule,MatCardModule,
      NbCheckboxModule,
      NbToggleModule
  ],
})
export class OptionsReportesComponent implements OnInit {
  constructor(
    private servicioAverias: AveriasService,
    private dateFormatter: DatePipe,
    private svcAnalytics: AnalyticsService
  ) {}

  grillaAverias = false;
  grillaModelo = false;
  grillaClasificacion = false;
  indicadores = false;
  detalleAverias = false;
  fotosAverias = false;
  showSpinner: boolean = false;
  idOperador: number;

  @Input() public data: reportesDTO;
  @Input() public idTipoOperador: number = 0;
  @Output() cerrar = new EventEmitter<any>();
  @Input() usarCheckbox: boolean;

  ngOnInit(): void {
    if (this.idTipoOperador == 4) {
      this.fotosAverias = true;
      this.detalleAverias = true;
    }
  }
  invocarReportes() {



    if (this.data.idTipoReporte == 11) {
      this.idOperador = Number(localStorage.getItem('idOperador'));
    } else {
      this.idOperador = 0;
    }
    let datosReportes: reportesDTO = {
      idVinAverias: this.data.idVinAverias,
      idTipoReporte: Number(this.data.idTipoReporte),
      transporte: '0',
      fechaDesde: this.data.fechaDesde,
      fechaHasta: this.data.fechaHasta,
      responsable: Number(this.data.responsable),
      procesos: this.data.procesos,
      vin: this.data.vin,
      grilla: this.grillaAverias,
      porModelo: this.grillaModelo,
      porClasif: this.grillaClasificacion,
      indicadores: this.indicadores,
      detalles: this.detalleAverias,
      fotos: this.fotosAverias,
      cantInsp: this.data.cantInsp,
      cantAverias: this.data.cantAverias,
      idReceptor: this.idOperador,
      codigoVisitaExterna : this.data.codigoVisitaExterna ?? "",
      idCliente : this.data.idCliente,
      idbuque: this.data.idbuque ? this.data.idbuque : 0, 
      filtrogrid: this.data.filtrogrid ? this.data.filtrogrid : []
    };
    this.showSpinner = true;

      if(this.data.idTipoReporte == 19) {
      datosReportes.grilla = true;
      }

    this.servicioAverias.postGenerarReporte(datosReportes).subscribe((data) => {
      if (data['status'] == 200) {
        alert('El reporte se genero correctamente');
        this.showPdf(data['body'].pdf, data['body'].nombre);
      } else {
        alert('Ha ocurrido un error al generar el reporte');
      }
      this.showSpinner = false;
      //gtag de reporte
      this.svcAnalytics.setAnalyticsReporteButton();
    });
  }
  showPdf(archivo, nombre: string) {
    var date = this.dateFormatter.transform(new Date(), 'dd-MM-yyyy');
    const linkSource = 'data:application/pdf;base64,' + archivo;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = nombre + '_' + date;
    downloadLink.click();
    this.cerrarModal();
  }
  cerrarModal() {
    this.cerrar.emit('cerrar');
  }
}
